//REGISTER PLUGIN AND ADD MATCHMEDIA-------------------------->
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
let mm = gsap.matchMedia();

// Obtener configuración de animaciones desde el objeto global
// Si no existe, usar valores por defecto
const config = window.microbioAnimationConfig || {
	"header-activate-threshold": 200,
	"header-deactivate-threshold": 150,
	"lenis-mobile-breakpoint": 768,
	"horizontal-scroll-breakpoint": 600,
	"animation-enter-start": "top 95%",
	"heading-enter-line-delay": 150,
	"blur-enter-duration": 0.6,
	"blur-enter-opacity": 0,
	"blur-px": 2,
	"blur-enter-stagger": 0.08,
	"blur-enter-start": "top 50%",
	"color-anim-start": "top bottom",
	"color-anim-end": "top top",
	"color-anim-scrub": 1,
	"color-anim-breakpoint": 768,
	"opacity-anim-duration": 1,
	"opacity-anim-alpha": 0,
	"opacity-anim-stagger": 0.05,
	"opacity-anim-start": "top center",
	"opacity-progress-duration": 1,
	"opacity-progress-alpha": 0.2,
	"opacity-progress-stagger": 0.05,
	"opacity-progress-start": "top 80%",
	"opacity-progress-end": "bottom 60%",
	"opacity-progress-scrub": 2,
	"goto-duration": 1.5,
	"goto-offset-y": 200,
	"rotate-degrees": 240,
	"rotate-breakpoint": 300,
	"rotate-scrub": 1,
	"img-corner-appear-duration": 0.8,
	"img-corner-appear-start": "top 50%",
};

window.microbioConfig = config;

// Función helper para obtener valor de config con fallback a default
const getConfigValue = (key, defaultValue) => {
	const value = config[key];
	return value === null || value === undefined || value === ""
		? defaultValue
		: value;
};

const c_header = document.querySelector(".on-scroll-header");

if (c_header) {
	const handleHeaderScroll = () => {
		const scrollY = window.scrollY || window.pageYOffset;
		const activateThreshold = config["header-activate-threshold"];
		const deactivateThreshold = config["header-deactivate-threshold"];

		// Si pasamos el umbral de activación, activamos
		if (scrollY > activateThreshold) {
			if (!c_header.classList.contains("is-active")) {
				c_header.classList.add("is-active");
			}
		}
		// Solo desactivamos si subimos por encima del umbral de desactivación (margen de seguridad)
		else if (scrollY < deactivateThreshold) {
			if (c_header.classList.contains("is-active")) {
				c_header.classList.remove("is-active");
			}
		}
	};
	// Escuchamos el evento scroll.
	// Es "passive" para no bloquear el hilo principal y usamos requestAnimationFrame para suavidad extrema.
	window.addEventListener(
		"scroll",
		() => {
			requestAnimationFrame(handleHeaderScroll);
		},
		{ passive: true },
	);
	// Ejecución inicial por si el usuario recarga la página ya con scroll
	handleHeaderScroll();
}

//LENIS SMOOTH SCROLL------------------------------------------>
if (typeof Lenis !== "undefined") {
	const LENIS_CONFIG = {
		notAllowedTemplateClasses: [
			"woocommerce-account",
			"woocommerce-checkout",
			"woocommerce-cart",
		],
		mobileBreakpoint: config["lenis-mobile-breakpoint"], // En px, Lenis se desactiva en mobile si no está en array
	};
	// Función para verificar si debemos cargar Lenis
	function shouldLoadLenis() {
		const bodyElement = document.body;
		const isMobile = window.innerWidth < LENIS_CONFIG.mobileBreakpoint;

		// Early return: nunca cargar en mobile
		if (isMobile) {
			return false;
		}

		// Verificar si el body no tiene alguna de las clases permitidas
		return !LENIS_CONFIG.notAllowedTemplateClasses.some((templateClass) =>
			bodyElement.classList.contains(templateClass),
		);
	}

	// Initialize Lenis solo si cumple las condiciones
	if (shouldLoadLenis()) {
		window.lenis = new Lenis();

		// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
		window.lenis.on("scroll", ScrollTrigger.update);

		// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
		// This ensures Lenis's smooth scroll animation updates on each GSAP tick
		gsap.ticker.add((time) => {
			window.lenis.raf(time * 1000); // Convert time from seconds to milliseconds
		});

		// Disable lag smoothing in GSAP to prevent any delay in scroll animations
		gsap.ticker.lagSmoothing(0);
	}
}

let horizontalScrollSections = document.querySelector(
	".wp-block-microbio-blocks-horizontal-scroll",
);

if (horizontalScrollSections) {
	mm.add("(min-width: 600px)", () => {
		gsap.to(horizontalScrollSections, {
			x: `-${horizontalScrollSections.childElementCount - 1}00vw`,
			ease: "linear",
			scrollTrigger: {
				start: "top -50%",
				end: `bottom -${horizontalScrollSections.childElementCount - 1}00%`,
				scrub: 1,
				trigger: horizontalScrollSections,
			},
		});
		ScrollTrigger.create({
			trigger: horizontalScrollSections,
			start: "top top",
			end: `bottom -${horizontalScrollSections.childElementCount - 1}90%`,
			pin: horizontalScrollSections,
		});
	});
}

//BASE ANIMATION START---------------------------------------------------------------->
const animationEnterElements = document.querySelectorAll(
	".gsap-animation-enter",
);
const animationScrollElements = document.querySelectorAll(
	".gsap-animation-scroll",
);

if (animationScrollElements && animationScrollElements.length) {
	animationScrollElements.forEach((el) => {
		const animationType = el.attributes["data-animation-scroll"].value;
		const animationMeasure =
			el.attributes["data-animation-scroll-measure"].value;
		const animationTypeMobile =
			el.attributes["data-animation-scroll-mobile"].value;
		const animationMeasureMobile =
			el.attributes["data-animation-scroll-mobile-measure"].value;
		mm.add("(min-width: 600px)", () => {
			let scrollTrigger = {
				start: "top bottom",
				end: "bottom top",
				scrub: true,
				trigger: el,
			};

			if (animationType === "top") {
				return gsap.to(el, {
					y: `-${animationMeasure}`,
					ease: "none",
					scrollTrigger,
				});
			}

			if (animationType === "bottom") {
				return gsap.to(el, {
					y: `${animationMeasure}`,
					ease: "none",
					scrollTrigger,
				});
			}
			if (animationType === "left") {
				return gsap.from(el, {
					x: `${animationMeasure}`,
					scrollTrigger,
				});
			}
			if (animationType === "right") {
				return gsap.from(el, {
					x: `-${animationMeasure}`,
					scrollTrigger,
				});
			}
			if (animationType === "rotation") {
				return gsap.to(el, {
					rotation: animationMeasure,
					scrollTrigger: {
						start: "top bottom",
						end: "bottom 50%",
						scrub: 1,
						trigger: el,
					},
				});
			}
			return;
		});
		mm.add("(max-width: 599px)", () => {
			let scrollTrigger = {
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
				trigger: el,
			};

			if (animationTypeMobile === "top") {
				return gsap.to(el, {
					y: `-${animationMeasureMobile}`,
					scrollTrigger,
				});
			}

			if (animationTypeMobile === "bottom") {
				return gsap.to(el, {
					y: `${animationMeasureMobile}`,
					scrollTrigger,
				});
			}
			if (animationTypeMobile === "left") {
				return gsap.from(el, {
					x: `${animationMeasureMobile}`,
					scrollTrigger,
				});
			}
			if (animationTypeMobile === "right") {
				return gsap.from(el, {
					x: `-${animationMeasureMobile}`,
					scrollTrigger,
				});
			}
			if (animationType === "rotation") {
				return gsap.to(el, {
					rotation: animationMeasureMobile,
					scrollTrigger: {
						start: "top bottom",
						end: "bottom 50%",
						scrub: 1,
						trigger: el,
					},
				});
			}
			return;
		});
	});
}
if (animationEnterElements && animationEnterElements.length) {
	animationEnterElements.forEach((el) => {
		let min = el.classList.contains("gsap-animation-enter-only-desktop")
			? "600"
			: "300";
		let delay = 0;
		const animationEnterDelay =
			el.attributes["data-animation-enter-delay"]?.value;
		if (animationEnterDelay) {
			delay = parseFloat(animationEnterDelay);
		}

		mm.add(`(min-width: ${min}px)`, () => {
			ScrollTrigger.create({
				trigger: el,
				start: "top 95%",

				onEnter: (self) => {
					setTimeout(() => {
						el.classList.add("active");
						self.disable();
					}, delay);
				},
			});
		});
	});
}

//Sección menu interno
// let innerAnchorLink = document.querySelectorAll(".menu-inner-link-anchor")
// if (innerAnchorLink && innerAnchorLink.length) {
//   mm.add("(min-width: 300px)", () => {
//     innerAnchorLink.forEach((anchorLink) => {
//       ScrollTrigger.create({
//         trigger: anchorLink.hash,
//         start: "top 50px",
//         onEnter: () => anchorLink.classList.add("active"),
//         onEnterBack: () => anchorLink.classList.add("active"),
//         onLeave: () => anchorLink.classList.remove("active"),
//         onLeaveBack: () => anchorLink.classList.remove("active"),
//       })
//     })
//   })
// }

//RESIZE EVENT--------------------------------------------------------->
const resizeObserver = new ResizeObserver((entries) =>
	gsap.matchMediaRefresh(),
);

resizeObserver.observe(document.body);

//Parallax en imagen de fondo (solo escritorio)
let parallaxSections = document.querySelectorAll(".section-parallax");
if (parallaxSections && parallaxSections.length) {
	mm.add("(min-width: 768px)", () => {
		parallaxSections.forEach((section) => {
			const parallaxDistance =
				section.getAttribute("data-parallax-distance") || "100px";

			// Calcular el distancia basada en la unidad
			let yDistance = parallaxDistance;

			let img = section.querySelector(".section-img-bg img");

			gsap.to(img, {
				y: yDistance,
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: 0,
					markers: false,
				},
			});
		});
	});
}

//Rotate
let rotateElements = document.querySelectorAll(".gsap-rotate");
if (rotateElements && rotateElements.forEach) {
	mm.add("(min-width: 300px)", () => {
		rotateElements.forEach((rotateElement) => {
			gsap.to(rotateElement, {
				rotate: `${config["rotate-degrees"]}deg`,
				ease: "linear",
				scrollTrigger: {
					start: "top bottom",
					end: "bottom top",
					scrub: config["rotate-scrub"],
					trigger: rotateElement,
				},
			});
		});
	});
}

//goto

let goToButtons = document.querySelectorAll(".go-to-section-arrow");
if (goToButtons && goToButtons.length) {
	goToButtons.forEach((btn) => {
		btn.addEventListener("click", function () {
			gsap.to(window, {
				duration: config["goto-duration"],
				scrollTo: {
					y: btn.attributes["data-url"].value,
					offsetY: config["goto-offset-y"],
				},
				ease: "power2",
			});
		});
	});
}

function microbioScrollTo(id) {
	if (window.lenis) {
		window.lenis.scrollTo(`#${id}`, {
			duration: config["goto-duration"],
			offset: config["goto-offset-y"],
		});
	} else {
		gsap.to(window, {
			duration: config["goto-duration"],
			scrollTo: {
				y: `#${id}`,
				offsetY: config["goto-offset-y"],
			},
			ease: "power2",
		});
	}
}

// Convierte un valor con unidad (px, vh, vw, %, rem, em) a píxeles
function microbioToPx(value) {
	if (typeof value === "number") return value;
	const match = String(value)
		.trim()
		.match(/^(-?\d*\.?\d+)\s*(px|vh|vw|%|rem|em)?$/i);
	if (!match) return NaN;

	const amount = Number.parseFloat(match[1]);
	const unit = (match[2] || "px").toLowerCase();
	const rootFontSize = Number.parseFloat(
		getComputedStyle(document.documentElement).fontSize,
	);

	switch (unit) {
		case "vh":
		case "%":
			return (amount * window.innerHeight) / 100;
		case "vw":
			return (amount * window.innerWidth) / 100;
		case "rem":
		case "em":
			return amount * rootFontSize;
		default:
			return amount;
	}
}

// Avanza (o retrocede si es negativo) el scroll la cantidad indicada desde la posición actual
// Ej: microbioScrollFor(500), microbioScrollFor("50vh"), microbioScrollFor("-10rem")
function microbioScrollFor(amount) {
	const px = microbioToPx(amount);
	if (!Number.isFinite(px)) return;

	if (window.lenis) {
		window.lenis.scrollTo(window.lenis.scroll + px, {
			duration: config["goto-duration"],
		});
	} else {
		gsap.to(window, {
			duration: config["goto-duration"],
			scrollTo: {
				y: window.scrollY + px,
			},
			ease: "power2",
		});
	}
}

//Animación de entrada de texto
const titlesToAnimate = document.querySelectorAll(
	".is-style-microbio-animations-heading-enter",
);

if (titlesToAnimate && titlesToAnimate.length) {
	// Función para procesar cada título después de cargar las fuentes
	const processTitle = (title) => {
		// Preservar el alineamiento original
		const originalTextAlign = window.getComputedStyle(title).textAlign;

		if (title.classList.contains("split-ready")) return; // Evita doble inicialización

		const split = new SplitType(title, {
			types: "lines",
			lineClass: "line",
		});

		// Envolver las líneas en máscaras
		const wrappers = [];
		split.lines.forEach((line) => {
			const wrapper = document.createElement("div");
			wrapper.classList.add("line-mask");
			wrapper.style.textAlign = originalTextAlign;
			line.parentNode.insertBefore(wrapper, line);
			wrapper.appendChild(line);
			wrappers.push(wrapper);
		});

		title.classList.add("split-ready");

		// Crear ScrollTrigger para activar la animación
		ScrollTrigger.create({
			trigger: title,
			start: "top bottom",
			onEnter: function (self) {
				// Añadir clase active a cada línea con stagger
				split.lines.forEach((line, index) => {
					setTimeout(() => {
						line.classList.add("active");
					}, index * config["heading-enter-line-delay"]); // Usar delay configurable
				});
				title.classList.add("active");

				// Calcular tiempo total de la animación y remover las máscaras
				const animationDuration = 600; // transition duration en ms (0.6s)
				const totalDelay =
					(split.lines.length - 1) * config["heading-enter-line-delay"] +
					animationDuration;
				setTimeout(() => {
					wrappers.forEach((wrapper) => {
						wrapper.classList.remove("line-mask");
					});
				}, totalDelay);

				self.disable(); // Desactivar después de ejecutar
			},
		});
	};

	titlesToAnimate.forEach(processTitle);
}

//Animación aparición con blur
const blurEnterElements = document.querySelectorAll(
	".is-style-microbio-animations-heading-blur-enter",
);

if (blurEnterElements && blurEnterElements.length) {
	blurEnterElements.forEach((title) => {
		if (title.classList.contains("blur-split-ready")) return; // Evita doble inicialización

		const split = new SplitType(title, {
			types: "chars",
			charClass: "blur-char",
		});

		title.classList.add("blur-split-ready");

		gsap.from(split.chars, {
			duration: config["blur-enter-duration"],
			opacity: config["blur-enter-opacity"],
			filter: `blur(${config["blur-px"]}px)`,
			stagger: config["blur-enter-stagger"],
			scrollTrigger: {
				trigger: title,
				start: config["blur-enter-start"],
				scrub: false,
				onToggle: (self) => self.disable(),
			},
		});
	});
}

//Animación color de fondo
let textBgRevealElements = document.querySelectorAll(
	".is-style-microbio-animations-heading-color",
);

textBgRevealElements.forEach((element) => {
	let lines = new SplitText(element, {
		type: "lines",
		linesClass: "text-bg-reveal",
		tag: "span",
	});
	mm.add("(min-width: 768px)", () => {
		lines.lines.forEach((line) => {
			gsap.fromTo(
				line,
				{
					backgroundPositionX: "90%",
				},
				{
					backgroundPositionX: "0%",
					scrollTrigger: {
						trigger: line,
						start: config["color-anim-start"],
						end: config["color-anim-end"],
						scrub: config["color-anim-scrub"],
						onToggle: (self) => self.disable(),
					},
				},
			);
		});
	});
});

//Animación opacidad
let opacityHeadeingAnimation = document.querySelectorAll(
	".is-style-microbio-animations-heading-opacity",
);

if (opacityHeadeingAnimation?.length > 0) {
	opacityHeadeingAnimation.forEach((text) => {
		let split = new SplitText(text, { type: "words" });
		gsap.from(split.words, {
			duration: config["opacity-anim-duration"],
			autoAlpha: config["opacity-anim-alpha"],
			stagger: config["opacity-anim-stagger"],
			scrollTrigger: {
				trigger: text,
				start: config["opacity-anim-start"],
				scrub: false,
				onToggle: (self) => self.disable(),
			},
		});
	});
}

let opacityHeadeingAnimationProgress = document.querySelectorAll(
	".is-style-microbio-animations-heading-opacity-progress",
);

if (opacityHeadeingAnimationProgress?.length > 0) {
	opacityHeadeingAnimationProgress.forEach((text) => {
		let split = new SplitText(text, { type: "words" });
		gsap.from(split.words, {
			duration: config["opacity-progress-duration"],
			autoAlpha: config["opacity-progress-alpha"],
			stagger: config["opacity-progress-stagger"],
			scrollTrigger: {
				trigger: text,
				start: config["opacity-progress-start"],
				end: config["opacity-progress-end"],
				scrub: config["opacity-progress-scrub"],
			},
		});
	});
}

let duplicateOnHover = document.querySelectorAll(
	".is-style-microbio-animations-hover-duplicate",
);

if (duplicateOnHover?.length > 0) {
	duplicateOnHover.forEach((word) => {
		let wordContent = word.textContent;

		let htmlConstructor = `<span class="hover-animation-word--original">${wordContent}</span><span class="hover-animation-word--reply" aria-hidden="true">${wordContent}</span>`;

		word.innerHTML = htmlConstructor;
	});
}

//link follow
let linkFollow = document.querySelectorAll(
	".is-style-microbio-animations-link-follow",
);
if (linkFollow?.length > 0) {
	linkFollow.forEach((parragraph) => {
		let markerHtml = `<span class="link-follow--marker"></span>`;

		parragraph.insertAdjacentHTML("beforeend", markerHtml);

		let markerElemenet = parragraph.querySelector(".link-follow--marker");

		let links = parragraph.querySelectorAll("a");

		if (links?.length > 0) {
			markerElemenet.style.width =
				links[0].getBoundingClientRect().width + "px";
			markerElemenet.style.height =
				links[0].getBoundingClientRect().height + "px";
		}
		links.forEach((link) => {
			link.innerHTML = `<span>${link.innerText}</span>`;
			link.addEventListener("mouseover", (event) => {
				markerElemenet.style.opacity = 1;
				markerElemenet.style.left =
					event.target.offsetParent.offsetLeft - 10 + "px";
				markerElemenet.style.top = event.target.offsetParent.offsetTop + "px";
				markerElemenet.style.width =
					event.target.getBoundingClientRect().width + 20 + "px";
			});

			link.addEventListener("mouseout", () => {
				markerElemenet.style.opacity = 0;
			});
		});
	});
}

//Animación imagen - Aparición desde esquinas con clip-path
// Mapeo de sufijos de esquinas a clipPath
const cornerClipPaths = {
	"top-left-corner": "inset(0 100% 100% 0)",
	"top-right-corner": "inset(0 0 100% 100%)",
	"bottom-left-corner": "inset(100% 100% 0 0)",
	"bottom-right-corner": "inset(100% 0 0 100%)",
};

let imgAppearElements = document.querySelectorAll(
	'[class*="is-style-microbio-animations-img"]',
);

if (imgAppearElements && imgAppearElements.length) {
	imgAppearElements.forEach((img) => {
		// Encontrar qué esquina tiene este elemento
		const classString = img.className;
		let clipPathValue = cornerClipPaths["top-left-corner"]; // Default

		Object.entries(cornerClipPaths).forEach(([corner, clipPath]) => {
			if (classString.includes(corner)) {
				clipPathValue = clipPath;
			}
		});

		const duration = getConfigValue("img-corner-appear-duration", 0.8);
		const startPoint = getConfigValue("img-corner-appear-start", "top 50%");

		gsap.from(img, {
			clipPath: clipPathValue,
			duration: duration,
			scrollTrigger: {
				trigger: img,
				start: startPoint,
				scrub: false,
				onToggle: (self) => self.disable(),
			},
		});
	});
}

function microbioOpenMobileMenu(
	blockScroll = false,
	id = "mobile-menu-container",
) {
	let btn = document.querySelector(".wp-block-microbio-blocks-button-menu");
	let menu = document.getElementById(id);
	if (menu) menu.classList.toggle("active");
	if (btn) btn.classList.toggle("active");
	if (blockScroll) {
		document.body.classList.toggle("no-scroll");
	}
}
